@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.progress {
  outline: 4px solid var(--default-secondary-color);
  background-color: var(--default-secondary-color);
  border-radius: 50%;
  svg {
    color: #ffffff !important;
  }
}

.field {
  z-index: 1;
}

.fieldError,
.fieldHelp {
  z-index: 0;
  display: inline-block;
  font-size: 83% !important;
  min-height:  hevo-toolkit-variables.$spacer * 1.25;
  font-weight:  hevo-toolkit-variables.$font-weight-medium !important;
  padding-left:  hevo-toolkit-variables.$spacer * 0.55 !important;
  margin-top:  hevo-toolkit-variables.$spacer * 0.25 !important;
}

.fieldError {
  color: var(--error-color) !important;
}
